(function () {
  function init(root) {
    const track = root.querySelector('.yb-mini-rev__track');
    const items = root.querySelectorAll('.yb-mini-rev__item');
    if (!track || items.length < 2) return;

    const interval = Number(root.dataset.interval || 3) * 1000;
    let idx = 0;
    let timer;

    function go(next) {
      idx = (next + items.length) % items.length;
      // RTL feel: move track in opposite direction
      track.style.transform = `translateX(${idx * 100 * -1}%)`;
    }

    function start() {
      stop();
      timer = setInterval(() => go(idx + 1), interval);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  }

  function boot() {
    document.querySelectorAll('[data-yb-mini-rev]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
